import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { DriverIsActiveRequestDto, ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class UpdateDriverIsActiveCommand extends IRequestCommand<
  IUpdateDriverIsActiveCommand,
  ErrorDetails,
  IUpdateDriverIsActiveCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carriers/{carrierUserId}/drivers/{driverUserId}/operability';

  override setParameters(parameters: IUpdateDriverIsActiveCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{driverUserId}',
      parameters.driverUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandBody = parameters;
  }
}

export interface IUpdateDriverIsActiveCommandParameters
  extends DriverIsActiveRequestDto,
    ICommandParameters {}

export interface IUpdateDriverIsActiveCommand extends ICommandResponse {
  errorCode?: string;
}
